import globalAxios from 'axios';
import { B as BaseAPI, a as assertParamExists, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * CustomContentApi - axios parameter creator
 * @export
 */
const CustomContentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Διαγραφή εγγραφής δυναμικού περιεχομένου με βάση entity και entityId (Auth policies: CMS)
         * @param {number} entityId Το id του δυναμικού περιεχομένου προς διαγραφή
         * @param {BizwebEntityType} entity
         * @param {string} [subkey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByEntity: async (entityId, entity, subkey, options = {}) => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('deleteByEntity', 'entityId', entityId);
            // verify required parameter 'entity' is not null or undefined
            assertParamExists('deleteByEntity', 'entity', entity);
            const localVarPath = `/v1/CustomContent/DeleteByEntity/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (entity !== undefined) {
                localVarQueryParameter['entity'] = entity;
            }
            if (subkey !== undefined) {
                localVarQueryParameter['subkey'] = subkey;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Επιστρέφει όλα τα δυναμικά περιεχόμενα (Auth policies: CMS)
         * @param {boolean} [includeTemp] true για να λαμβάνει υπ\&#39; όψιν και τα temp περιεχόμενα
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (includeTemp, options = {}) => {
            const localVarPath = `/v1/CustomContent/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (includeTemp !== undefined) {
                localVarQueryParameter['includeTemp'] = includeTemp;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Επιστρέφει δυναμικό περιεχόμενο με βάση τον κωδικό του.
         * @param {string} code Ο κωδικός περιεχομένου με βάση τον οποίο γίνεται η αναζήτηση
         * @param {boolean} [isTemp] true για να γίνει αναζήτηση και στα temp περιεχόμενα
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCode: async (code, isTemp, options = {}) => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getByCode', 'code', code);
            const localVarPath = `/v1/CustomContent/GetByCode/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (isTemp !== undefined) {
                localVarQueryParameter['isTemp'] = isTemp;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Επιστρέφει δυναμικό περιεχόμενο με βάση το entity id στο οποίο είναι attached.
         * @param {number} entityId Το id του entity για το οποίο θέλουμε να πάρουμε το content
         * @param {BizwebEntityType} entity Ο τύπος του entity για το οποίο θέλουμε να πάρουμε το content
         * @param {string} [subkey] Το subkey του περιεχομένου για το συγκεκριμένο entity
         * @param {boolean} [fallbackToDefaultLanguage] Αν είναι true τότε αν δεν υπάρχει το περιεχόμενο στην ζητούμενη γλώσσα, επιστρέφει το περιεχόμενο στην default γλώσσα
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByEntity: async (entityId, entity, subkey, fallbackToDefaultLanguage, options = {}) => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getByEntity', 'entityId', entityId);
            // verify required parameter 'entity' is not null or undefined
            assertParamExists('getByEntity', 'entity', entity);
            const localVarPath = `/v1/CustomContent/GetByEntity/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (entity !== undefined) {
                localVarQueryParameter['entity'] = entity;
            }
            if (subkey !== undefined) {
                localVarQueryParameter['subkey'] = subkey;
            }
            if (fallbackToDefaultLanguage !== undefined) {
                localVarQueryParameter['fallbackToDefaultLanguage'] = fallbackToDefaultLanguage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Admin-only entity-keyed read that INCLUDES temporary (draft) content. Mirrors M:BizWeb.NC.API.Controllers.CMS.CustomContentController.GetByEntity(System.Int32,BizWeb.NC.Base.Enumerations.BizwebEntityType,System.String,System.Nullable{System.Boolean}) but bypasses the global query filter (which hides temporary records from public reads), so the page-builder editor can reload a draft and authorized users can preview it on the storefront. (Auth policies: CMS)
         * @param {number} entityId Το id του entity για το οποίο θέλουμε να πάρουμε το content
         * @param {BizwebEntityType} entity Ο τύπος του entity για το οποίο θέλουμε να πάρουμε το content
         * @param {string} [subkey] Το subkey του περιεχομένου για το συγκεκριμένο entity
         * @param {boolean} [fallbackToDefaultLanguage] Αν είναι true τότε αν δεν υπάρχει το περιεχόμενο στην ζητούμενη γλώσσα, επιστρέφει το περιεχόμενο στην default γλώσσα
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByEntityIncludingTemp: async (entityId, entity, subkey, fallbackToDefaultLanguage, options = {}) => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getByEntityIncludingTemp', 'entityId', entityId);
            // verify required parameter 'entity' is not null or undefined
            assertParamExists('getByEntityIncludingTemp', 'entity', entity);
            const localVarPath = `/v1/CustomContent/GetByEntityIncludingTemp/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (entity !== undefined) {
                localVarQueryParameter['entity'] = entity;
            }
            if (subkey !== undefined) {
                localVarQueryParameter['subkey'] = subkey;
            }
            if (fallbackToDefaultLanguage !== undefined) {
                localVarQueryParameter['fallbackToDefaultLanguage'] = fallbackToDefaultLanguage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Επιστρέφει δυναμικό περιεχόμενο με βάση το ID του.
         * @param {number} id
         * @param {boolean} [includeTemp] true για να λαμβάνει υπ\&#39; όψιν και τα temp περιεχόμενα
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, includeTemp, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getById', 'id', id);
            const localVarPath = `/v1/CustomContent/GetById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (includeTemp !== undefined) {
                localVarQueryParameter['includeTemp'] = includeTemp;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Επιστρέφει πολλαπλά δυναμικά περιεχόμενα με βάση τα ids τους.
         * @param {Array<number>} request_body
         * @param {boolean} [includeTemp]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds: async (request_body, includeTemp, options = {}) => {
            // verify required parameter 'request_body' is not null or undefined
            assertParamExists('getByIds', 'request_body', request_body);
            const localVarPath = `/v1/CustomContent/GetByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (includeTemp !== undefined) {
                localVarQueryParameter['includeTemp'] = includeTemp;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Επιστρέφει λίστα από δυναμικά περιεχόμενα με βάση paging, sorting και filtering (Auth policies: CMS)
         * @param {CustomContentListRequest} CustomContentListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getList: async (CustomContentListRequest, options = {}) => {
            // verify required parameter 'CustomContentListRequest' is not null or undefined
            assertParamExists('getList', 'CustomContentListRequest', CustomContentListRequest);
            const localVarPath = `/v1/CustomContent/GetList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CustomContentListRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Δημιουργία νέας εγγραφής δυναμικού περιεχομένου (Auth policies: CMS)
         * @param {CustomContentToken} CustomContentToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (CustomContentToken, options = {}) => {
            // verify required parameter 'CustomContentToken' is not null or undefined
            assertParamExists('insert', 'CustomContentToken', CustomContentToken);
            const localVarPath = `/v1/CustomContent/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CustomContentToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Διαγραφή εγγραφής δυναμικού περιεχομένου (Auth policies: CMS)
         * @param {number} id Το id του δυναμικού περιεχομένου προς διαγραφή
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id);
            const localVarPath = `/v1/CustomContent/Delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Saves (upserts) a custom content record (Auth policies: CMS)
         * @param {CustomContentToken} CustomContentToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save: async (CustomContentToken, options = {}) => {
            // verify required parameter 'CustomContentToken' is not null or undefined
            assertParamExists('save', 'CustomContentToken', CustomContentToken);
            const localVarPath = `/v1/CustomContent/Save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CustomContentToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Επεξεργασία εγγραφής δυναμικού περιεχομένου (Auth policies: CMS)
         * @param {CustomContentToken} CustomContentToken Τα νέα data του δυναμικού περιεχομένου
         * @param {number} id Το id του δυναμικού περιεχομένου προς επεξεργασία
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (CustomContentToken, id, options = {}) => {
            // verify required parameter 'CustomContentToken' is not null or undefined
            assertParamExists('update', 'CustomContentToken', CustomContentToken);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id);
            const localVarPath = `/v1/CustomContent/Update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CustomContentToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Αποθήκευση περιεχομένου (data) δυναμικού περιεχομένου (Auth policies: CMS)
         * @param {CustomContentUpdateDataModel} CustomContentUpdateDataModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateData: async (CustomContentUpdateDataModel, options = {}) => {
            // verify required parameter 'CustomContentUpdateDataModel' is not null or undefined
            assertParamExists('updateData', 'CustomContentUpdateDataModel', CustomContentUpdateDataModel);
            const localVarPath = `/v1/CustomContent/UpdateData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CustomContentUpdateDataModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CustomContentApi - functional programming interface
 * @export
 */
const CustomContentApiFp = function (configuration) {
    const localVarAxiosParamCreator = CustomContentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Διαγραφή εγγραφής δυναμικού περιεχομένου με βάση entity και entityId (Auth policies: CMS)
         * @param {number} entityId Το id του δυναμικού περιεχομένου προς διαγραφή
         * @param {BizwebEntityType} entity
         * @param {string} [subkey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteByEntity(entityId, entity, subkey, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteByEntity(entityId, entity, subkey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomContentApi.deleteByEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Επιστρέφει όλα τα δυναμικά περιεχόμενα (Auth policies: CMS)
         * @param {boolean} [includeTemp] true για να λαμβάνει υπ\&#39; όψιν και τα temp περιεχόμενα
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(includeTemp, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(includeTemp, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomContentApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Επιστρέφει δυναμικό περιεχόμενο με βάση τον κωδικό του.
         * @param {string} code Ο κωδικός περιεχομένου με βάση τον οποίο γίνεται η αναζήτηση
         * @param {boolean} [isTemp] true για να γίνει αναζήτηση και στα temp περιεχόμενα
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByCode(code, isTemp, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByCode(code, isTemp, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomContentApi.getByCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Επιστρέφει δυναμικό περιεχόμενο με βάση το entity id στο οποίο είναι attached.
         * @param {number} entityId Το id του entity για το οποίο θέλουμε να πάρουμε το content
         * @param {BizwebEntityType} entity Ο τύπος του entity για το οποίο θέλουμε να πάρουμε το content
         * @param {string} [subkey] Το subkey του περιεχομένου για το συγκεκριμένο entity
         * @param {boolean} [fallbackToDefaultLanguage] Αν είναι true τότε αν δεν υπάρχει το περιεχόμενο στην ζητούμενη γλώσσα, επιστρέφει το περιεχόμενο στην default γλώσσα
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByEntity(entityId, entity, subkey, fallbackToDefaultLanguage, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByEntity(entityId, entity, subkey, fallbackToDefaultLanguage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomContentApi.getByEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Admin-only entity-keyed read that INCLUDES temporary (draft) content. Mirrors M:BizWeb.NC.API.Controllers.CMS.CustomContentController.GetByEntity(System.Int32,BizWeb.NC.Base.Enumerations.BizwebEntityType,System.String,System.Nullable{System.Boolean}) but bypasses the global query filter (which hides temporary records from public reads), so the page-builder editor can reload a draft and authorized users can preview it on the storefront. (Auth policies: CMS)
         * @param {number} entityId Το id του entity για το οποίο θέλουμε να πάρουμε το content
         * @param {BizwebEntityType} entity Ο τύπος του entity για το οποίο θέλουμε να πάρουμε το content
         * @param {string} [subkey] Το subkey του περιεχομένου για το συγκεκριμένο entity
         * @param {boolean} [fallbackToDefaultLanguage] Αν είναι true τότε αν δεν υπάρχει το περιεχόμενο στην ζητούμενη γλώσσα, επιστρέφει το περιεχόμενο στην default γλώσσα
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByEntityIncludingTemp(entityId, entity, subkey, fallbackToDefaultLanguage, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByEntityIncludingTemp(entityId, entity, subkey, fallbackToDefaultLanguage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomContentApi.getByEntityIncludingTemp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Επιστρέφει δυναμικό περιεχόμενο με βάση το ID του.
         * @param {number} id
         * @param {boolean} [includeTemp] true για να λαμβάνει υπ\&#39; όψιν και τα temp περιεχόμενα
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, includeTemp, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, includeTemp, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomContentApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Επιστρέφει πολλαπλά δυναμικά περιεχόμενα με βάση τα ids τους.
         * @param {Array<number>} request_body
         * @param {boolean} [includeTemp]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIds(request_body, includeTemp, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIds(request_body, includeTemp, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomContentApi.getByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Επιστρέφει λίστα από δυναμικά περιεχόμενα με βάση paging, sorting και filtering (Auth policies: CMS)
         * @param {CustomContentListRequest} CustomContentListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getList(CustomContentListRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getList(CustomContentListRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomContentApi.getList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Δημιουργία νέας εγγραφής δυναμικού περιεχομένου (Auth policies: CMS)
         * @param {CustomContentToken} CustomContentToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(CustomContentToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(CustomContentToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomContentApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Διαγραφή εγγραφής δυναμικού περιεχομένου (Auth policies: CMS)
         * @param {number} id Το id του δυναμικού περιεχομένου προς διαγραφή
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomContentApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Saves (upserts) a custom content record (Auth policies: CMS)
         * @param {CustomContentToken} CustomContentToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async save(CustomContentToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.save(CustomContentToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomContentApi.save']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Επεξεργασία εγγραφής δυναμικού περιεχομένου (Auth policies: CMS)
         * @param {CustomContentToken} CustomContentToken Τα νέα data του δυναμικού περιεχομένου
         * @param {number} id Το id του δυναμικού περιεχομένου προς επεξεργασία
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(CustomContentToken, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(CustomContentToken, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomContentApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Αποθήκευση περιεχομένου (data) δυναμικού περιεχομένου (Auth policies: CMS)
         * @param {CustomContentUpdateDataModel} CustomContentUpdateDataModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateData(CustomContentUpdateDataModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateData(CustomContentUpdateDataModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomContentApi.updateData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CustomContentApi - factory interface
 * @export
 */
const CustomContentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CustomContentApiFp(configuration);
    return {
        /**
         *
         * @summary Διαγραφή εγγραφής δυναμικού περιεχομένου με βάση entity και entityId (Auth policies: CMS)
         * @param {number} entityId Το id του δυναμικού περιεχομένου προς διαγραφή
         * @param {BizwebEntityType} entity
         * @param {string} [subkey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByEntity(entityId, entity, subkey, options) {
            return localVarFp.deleteByEntity(entityId, entity, subkey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Επιστρέφει όλα τα δυναμικά περιεχόμενα (Auth policies: CMS)
         * @param {boolean} [includeTemp] true για να λαμβάνει υπ\&#39; όψιν και τα temp περιεχόμενα
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(includeTemp, options) {
            return localVarFp.getAll(includeTemp, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Επιστρέφει δυναμικό περιεχόμενο με βάση τον κωδικό του.
         * @param {string} code Ο κωδικός περιεχομένου με βάση τον οποίο γίνεται η αναζήτηση
         * @param {boolean} [isTemp] true για να γίνει αναζήτηση και στα temp περιεχόμενα
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCode(code, isTemp, options) {
            return localVarFp.getByCode(code, isTemp, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Επιστρέφει δυναμικό περιεχόμενο με βάση το entity id στο οποίο είναι attached.
         * @param {number} entityId Το id του entity για το οποίο θέλουμε να πάρουμε το content
         * @param {BizwebEntityType} entity Ο τύπος του entity για το οποίο θέλουμε να πάρουμε το content
         * @param {string} [subkey] Το subkey του περιεχομένου για το συγκεκριμένο entity
         * @param {boolean} [fallbackToDefaultLanguage] Αν είναι true τότε αν δεν υπάρχει το περιεχόμενο στην ζητούμενη γλώσσα, επιστρέφει το περιεχόμενο στην default γλώσσα
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByEntity(entityId, entity, subkey, fallbackToDefaultLanguage, options) {
            return localVarFp.getByEntity(entityId, entity, subkey, fallbackToDefaultLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Admin-only entity-keyed read that INCLUDES temporary (draft) content. Mirrors M:BizWeb.NC.API.Controllers.CMS.CustomContentController.GetByEntity(System.Int32,BizWeb.NC.Base.Enumerations.BizwebEntityType,System.String,System.Nullable{System.Boolean}) but bypasses the global query filter (which hides temporary records from public reads), so the page-builder editor can reload a draft and authorized users can preview it on the storefront. (Auth policies: CMS)
         * @param {number} entityId Το id του entity για το οποίο θέλουμε να πάρουμε το content
         * @param {BizwebEntityType} entity Ο τύπος του entity για το οποίο θέλουμε να πάρουμε το content
         * @param {string} [subkey] Το subkey του περιεχομένου για το συγκεκριμένο entity
         * @param {boolean} [fallbackToDefaultLanguage] Αν είναι true τότε αν δεν υπάρχει το περιεχόμενο στην ζητούμενη γλώσσα, επιστρέφει το περιεχόμενο στην default γλώσσα
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByEntityIncludingTemp(entityId, entity, subkey, fallbackToDefaultLanguage, options) {
            return localVarFp.getByEntityIncludingTemp(entityId, entity, subkey, fallbackToDefaultLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Επιστρέφει δυναμικό περιεχόμενο με βάση το ID του.
         * @param {number} id
         * @param {boolean} [includeTemp] true για να λαμβάνει υπ\&#39; όψιν και τα temp περιεχόμενα
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, includeTemp, options) {
            return localVarFp.getById(id, includeTemp, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Επιστρέφει πολλαπλά δυναμικά περιεχόμενα με βάση τα ids τους.
         * @param {Array<number>} request_body
         * @param {boolean} [includeTemp]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds(request_body, includeTemp, options) {
            return localVarFp.getByIds(request_body, includeTemp, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Επιστρέφει λίστα από δυναμικά περιεχόμενα με βάση paging, sorting και filtering (Auth policies: CMS)
         * @param {CustomContentListRequest} CustomContentListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getList(CustomContentListRequest, options) {
            return localVarFp.getList(CustomContentListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Δημιουργία νέας εγγραφής δυναμικού περιεχομένου (Auth policies: CMS)
         * @param {CustomContentToken} CustomContentToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(CustomContentToken, options) {
            return localVarFp.insert(CustomContentToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Διαγραφή εγγραφής δυναμικού περιεχομένου (Auth policies: CMS)
         * @param {number} id Το id του δυναμικού περιεχομένου προς διαγραφή
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Saves (upserts) a custom content record (Auth policies: CMS)
         * @param {CustomContentToken} CustomContentToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save(CustomContentToken, options) {
            return localVarFp.save(CustomContentToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Επεξεργασία εγγραφής δυναμικού περιεχομένου (Auth policies: CMS)
         * @param {CustomContentToken} CustomContentToken Τα νέα data του δυναμικού περιεχομένου
         * @param {number} id Το id του δυναμικού περιεχομένου προς επεξεργασία
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(CustomContentToken, id, options) {
            return localVarFp.update(CustomContentToken, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Αποθήκευση περιεχομένου (data) δυναμικού περιεχομένου (Auth policies: CMS)
         * @param {CustomContentUpdateDataModel} CustomContentUpdateDataModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateData(CustomContentUpdateDataModel, options) {
            return localVarFp.updateData(CustomContentUpdateDataModel, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CustomContentApi - object-oriented interface
 * @export
 * @class CustomContentApi
 * @extends {BaseAPI}
 */
class CustomContentApi extends BaseAPI {
    /**
     *
     * @summary Διαγραφή εγγραφής δυναμικού περιεχομένου με βάση entity και entityId (Auth policies: CMS)
     * @param {number} entityId Το id του δυναμικού περιεχομένου προς διαγραφή
     * @param {BizwebEntityType} entity
     * @param {string} [subkey]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomContentApi
     */
    deleteByEntity(entityId, entity, subkey, options) {
        return CustomContentApiFp(this.configuration).deleteByEntity(entityId, entity, subkey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Επιστρέφει όλα τα δυναμικά περιεχόμενα (Auth policies: CMS)
     * @param {boolean} [includeTemp] true για να λαμβάνει υπ\&#39; όψιν και τα temp περιεχόμενα
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomContentApi
     */
    getAll(includeTemp, options) {
        return CustomContentApiFp(this.configuration).getAll(includeTemp, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Επιστρέφει δυναμικό περιεχόμενο με βάση τον κωδικό του.
     * @param {string} code Ο κωδικός περιεχομένου με βάση τον οποίο γίνεται η αναζήτηση
     * @param {boolean} [isTemp] true για να γίνει αναζήτηση και στα temp περιεχόμενα
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomContentApi
     */
    getByCode(code, isTemp, options) {
        return CustomContentApiFp(this.configuration).getByCode(code, isTemp, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Επιστρέφει δυναμικό περιεχόμενο με βάση το entity id στο οποίο είναι attached.
     * @param {number} entityId Το id του entity για το οποίο θέλουμε να πάρουμε το content
     * @param {BizwebEntityType} entity Ο τύπος του entity για το οποίο θέλουμε να πάρουμε το content
     * @param {string} [subkey] Το subkey του περιεχομένου για το συγκεκριμένο entity
     * @param {boolean} [fallbackToDefaultLanguage] Αν είναι true τότε αν δεν υπάρχει το περιεχόμενο στην ζητούμενη γλώσσα, επιστρέφει το περιεχόμενο στην default γλώσσα
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomContentApi
     */
    getByEntity(entityId, entity, subkey, fallbackToDefaultLanguage, options) {
        return CustomContentApiFp(this.configuration).getByEntity(entityId, entity, subkey, fallbackToDefaultLanguage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Admin-only entity-keyed read that INCLUDES temporary (draft) content. Mirrors M:BizWeb.NC.API.Controllers.CMS.CustomContentController.GetByEntity(System.Int32,BizWeb.NC.Base.Enumerations.BizwebEntityType,System.String,System.Nullable{System.Boolean}) but bypasses the global query filter (which hides temporary records from public reads), so the page-builder editor can reload a draft and authorized users can preview it on the storefront. (Auth policies: CMS)
     * @param {number} entityId Το id του entity για το οποίο θέλουμε να πάρουμε το content
     * @param {BizwebEntityType} entity Ο τύπος του entity για το οποίο θέλουμε να πάρουμε το content
     * @param {string} [subkey] Το subkey του περιεχομένου για το συγκεκριμένο entity
     * @param {boolean} [fallbackToDefaultLanguage] Αν είναι true τότε αν δεν υπάρχει το περιεχόμενο στην ζητούμενη γλώσσα, επιστρέφει το περιεχόμενο στην default γλώσσα
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomContentApi
     */
    getByEntityIncludingTemp(entityId, entity, subkey, fallbackToDefaultLanguage, options) {
        return CustomContentApiFp(this.configuration).getByEntityIncludingTemp(entityId, entity, subkey, fallbackToDefaultLanguage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Επιστρέφει δυναμικό περιεχόμενο με βάση το ID του.
     * @param {number} id
     * @param {boolean} [includeTemp] true για να λαμβάνει υπ\&#39; όψιν και τα temp περιεχόμενα
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomContentApi
     */
    getById(id, includeTemp, options) {
        return CustomContentApiFp(this.configuration).getById(id, includeTemp, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Επιστρέφει πολλαπλά δυναμικά περιεχόμενα με βάση τα ids τους.
     * @param {Array<number>} request_body
     * @param {boolean} [includeTemp]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomContentApi
     */
    getByIds(request_body, includeTemp, options) {
        return CustomContentApiFp(this.configuration).getByIds(request_body, includeTemp, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Επιστρέφει λίστα από δυναμικά περιεχόμενα με βάση paging, sorting και filtering (Auth policies: CMS)
     * @param {CustomContentListRequest} CustomContentListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomContentApi
     */
    getList(CustomContentListRequest, options) {
        return CustomContentApiFp(this.configuration).getList(CustomContentListRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Δημιουργία νέας εγγραφής δυναμικού περιεχομένου (Auth policies: CMS)
     * @param {CustomContentToken} CustomContentToken
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomContentApi
     */
    insert(CustomContentToken, options) {
        return CustomContentApiFp(this.configuration).insert(CustomContentToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Διαγραφή εγγραφής δυναμικού περιεχομένου (Auth policies: CMS)
     * @param {number} id Το id του δυναμικού περιεχομένου προς διαγραφή
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomContentApi
     */
    remove(id, options) {
        return CustomContentApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Saves (upserts) a custom content record (Auth policies: CMS)
     * @param {CustomContentToken} CustomContentToken
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomContentApi
     */
    save(CustomContentToken, options) {
        return CustomContentApiFp(this.configuration).save(CustomContentToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Επεξεργασία εγγραφής δυναμικού περιεχομένου (Auth policies: CMS)
     * @param {CustomContentToken} CustomContentToken Τα νέα data του δυναμικού περιεχομένου
     * @param {number} id Το id του δυναμικού περιεχομένου προς επεξεργασία
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomContentApi
     */
    update(CustomContentToken, id, options) {
        return CustomContentApiFp(this.configuration).update(CustomContentToken, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Αποθήκευση περιεχομένου (data) δυναμικού περιεχομένου (Auth policies: CMS)
     * @param {CustomContentUpdateDataModel} CustomContentUpdateDataModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomContentApi
     */
    updateData(CustomContentUpdateDataModel, options) {
        return CustomContentApiFp(this.configuration).updateData(CustomContentUpdateDataModel, options).then((request) => request(this.axios, this.basePath));
    }
}

export { CustomContentApi, CustomContentApiAxiosParamCreator, CustomContentApiFactory, CustomContentApiFp };
//# sourceMappingURL=custom-content-api.js.map
